__turbopack_context__.v({
  "bg": "DdXgiW_bg",
  "content": "DdXgiW_content",
  "flow": "DdXgiW_flow",
  "frame": "DdXgiW_frame",
  "heroEntry": "DdXgiW_heroEntry",
  "lede": "DdXgiW_lede",
  "searchSlot": "DdXgiW_searchSlot",
  "title": "DdXgiW_title",
  "wrap": "DdXgiW_wrap",
});
